import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  CloneTestCaseParams,
  TestCase
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  testCaseId: string
  params: CloneTestCaseParams
  onSuccess: (response: TestCase) => void
  children: () => ReactElement
}

const CloneModelerScriptTestCaseRequest = ({
  testCaseId,
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/scripted/${testCaseId}/clone`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CloneModelerScriptTestCaseRequest
